import { fetch, Method } from 'core/api/fetch';
import { isValidPositiveInteger } from '@utriper/core';

const PricingRoutes = {
    quote: '/api/v2.0/pricing/quote',
};

const parseItem = (item, overrideAvailability) => {
    const totalQuantity = item?.units?.reduce((acc, item) => acc + Number(item?.quantity || 0), 0);
    const units = item?.units
        ?.filter((unit) => isValidPositiveInteger(unit?.quantity))
        ?.map((unit) => ({
            unitId: unit?.id,
            quantity: unit?.quantity,
        }));

    const baseItem = {
        experienceId: item?.experienceId,
        experienceDetailId: item?.experienceDetailId,
        availabilityId: item?.availabilityId || null,
        bundleId: item?.bundleId || null,
        units,
    };

    if (overrideAvailability) {
        const overridePrice = item?.overridePrice || 0;
        baseItem.price = overridePrice;
        baseItem.currency = item?.overrideCurrency;
        const dividedPrice = overridePrice / totalQuantity;
        baseItem.units = units?.map((unit) => ({ ...unit, price: dividedPrice }));
    }

    return baseItem;
};

const parseUnitPricing = (unitPricing = []) =>
    unitPricing?.map((unit) => ({
        ...unit,
        finalPrice: unit?.finalPrice || unit?.price || 0,
    }));

export const PricingService = {
    quote: async ({ item, contractId, overrideAvailability, targetCurrency }) => {
        try {
            const { data } = await fetch(PricingRoutes.quote, {
                method: Method.POST,
                authenticated: true,
                data: {
                    item: parseItem(item, overrideAvailability),
                    contractId,
                    overrideAvailability,
                    targetCurrency,
                },
            });

            if (!data || Object.values(data ?? {}).length <= 0) {
                return {};
            }

            return {
                ...data,
                unitPricing: parseUnitPricing(data?.unitPricing ?? []),
            };
        } catch (error) {
            throw error;
        }
    },
};
